import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/buildhome/repo/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/opt/buildhome/repo/components/ui/accordion.tsx");
